import { render } from "./move_projectfolder.vue?vue&type=template&id=e5dceda6&scoped=true"
import script from "./move_projectfolder.js?vue&type=script&lang=js"
export * from "./move_projectfolder.js?vue&type=script&lang=js"

import "./move_projectfolder.vue?vue&type=style&index=0&id=e5dceda6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5dceda6"]])

export default __exports__